<template>
  <v-stepper v-model="estagioForm">
    <v-stepper-header>
      <v-text-field
        v-model="tamanhoTela"
        :label="locale[local].screen.formDependenteResponsivo.nomeLabel"
        filled
        v-show="false"
      ></v-text-field>

      <template v-for="index in quantidadePassos">
        <v-stepper-step :key="index" :step="index"></v-stepper-step>
        <v-divider
          v-if="index !== quantidadePassos"
          :key="'d' + index"
        ></v-divider>
      </template>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content
        v-for="index in quantidadePassos"
        :key="index"
        :step="index"
      >
        <v-card v-if="index === 1" outlined class="mb-8 mx-2 pa-2">
          <v-form
            ref="formDadosGerais"
            v-model="validDadosGerais"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="8" class="pb-2">
                <v-text-field
                  v-model="dependente.nome"
                  :label="locale[local].screen.formDependenteResponsivo.nomeLabel"
                  filled
                  :rules="[v => !!v || locale[local].rules.nomeObrigatorioLabel]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pb-2">
                <v-radio-group v-model="dependente.sexo" row>
                  {{ locale[local].screen.formDependenteResponsivo.sexoLabel }}:
                  <v-radio
                    color="primary"
                    :label="locale[local].screen.formDependenteResponsivo.masculinoLabel"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    color="primary"
                    :label="locale[local].screen.formDependenteResponsivo.femininoLabel"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-select
                  v-model="dependente.codDependencia"
                  :items="listaDependencias"
                  item-text="descricao"
                  item-value="codDependencia"
                  :label="locale[local].screen.formDependenteResponsivo.grauDependenciaLabel"
                  filled
                  :rules="[v => !!v || locale[local].rules.grauInstrucaoObrigatorio]"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  name="cpf"
                  :label="locale[local].screen.formDependenteResponsivo.cpfLabel"
                  type="text"
                  v-model="dependente.cpf"
                  return-masked-value
                  v-mask="maskCPF"
                  filled
                  :rules="[v => !!v || locale[local].rules.cpfLabel]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-menu
                  ref="menuNascimento"
                  v-model="menuNascimento"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dependente.dataNascimento"
                      :label="locale[local].screen.formDependenteResponsivo.nascimentoLabel"
                      v-mask="maskData"
                      persistent-hint
                      filled
                      v-on="on"
                      :rules="nascimentoRules"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateNascimento"
                    no-title
                    @input="menuNascimento = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-card
          v-if="
            (index === 1 && quantidadePassos === 2) ||
              (index === 2 && quantidadePassos === 4)
          "
          outlined
          class="mb-8 mx-2 pa-2"
        >
          <v-form
            ref="formDadosAdicionais"
            v-model="validDadosAdicionais"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="6" class="pb-2">
                <v-text-field
                  v-model="dependente.nomePai"
                  :label="locale[local].screen.formDependenteResponsivo.nomePaiLabel"
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pb-2">
                <v-text-field
                  v-model="dependente.nomeMae"
                  :label="locale[local].screen.formDependenteResponsivo.nomeMaeLabel"
                  filled
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dependente.CEP"
                  @blur="getCidadeCEP"
                  v-mask="maskCep"
                  return-masked-value
                  label="CEP"
                  :rules="cepRules"
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dependente.cidade"
                  :label="locale[local].screen.formDependenteResponsivo.cidadeLabel"
                  filled
                  :rules="[v => !!v || locale[local].rules.cidadeLabel]"
                  :disabled="desabilitarLocalidade"
                  required
                ></v-text-field
              ></v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-select
                  v-model="dependente.uf"
                  :items="listaUFs"
                  item-text="nome"
                  item-value="codUf"
                  label="UF"
                  filled
                  :rules="[v => !!v || locale[local].rules.ufObrigatorioLabel]"
                  :disabled="desabilitarLocalidade"
                  required
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-card
          v-if="
            (index === 2 && quantidadePassos === 2) ||
              (index === 3 && quantidadePassos === 4)
          "
          outlined
          class="mb-8 mx-2 pa-2"
        >
          <v-form
            ref="formDadosMatricula"
            v-model="validDadosMatricula"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="4" class="pb-2">
                <v-text-field
                  v-model.number="dependente.numeroCertidao"
                  :label="locale[local].screen.formDependenteResponsivo.numCertidaoLabel"
                  v-mask="maskNumCertidao"
                  :maxlength="7"
                  return-masked-value
                  
                  filled
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pb-2">
                <v-text-field
                  v-model="dependente.livro"
                  :label="locale[local].screen.formDependenteResponsivo.livroLabel"
                  filled
                
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pb-2">
                <v-text-field
                  v-model="dependente.folha"
                  :label="locale[local].screen.formDependenteResponsivo.folhaLabel"
                  filled
                 
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-text-field
                  v-model="dependente.matriculaCertidao"
                   :label="locale[local].screen.formDependenteResponsivo.matriculaCertidaoLabel"
                  filled
                  :rules="[v => !!v || locale[local].rules.matriculaLabel]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="pt-0 pb-2">
                <v-menu
                  ref="menuCertidao"
                  v-model="menuCertidao"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dependente.dataCertidao"
                       :label="locale[local].screen.formDependenteResponsivo.dataCertidaoLabel"
                      v-mask="maskData"
                      persistent-hint
                      filled
                      :rules="[
                        certidaoRules.dataValida,
                        certidaoRules.required
                      ]"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateCertidao"
                    no-title
                    @input="menuCertidao = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-card
          v-if="
            (index === 2 && quantidadePassos === 2) ||
              (index === 4 && quantidadePassos === 4)
          "
          outlined
          class="mb-8 mx-2 pa-2"
        >
          <v-form
            ref="formDependente"
            v-model="validDadosDependente"
            lazy-validation
          >
            <v-row>
              <v-col cols="12" md="4" class="pb-2">
                <v-checkbox
                  v-model="dependente.estudante"
                 
                   :label="locale[local].screen.formDependenteResponsivo.estudanteLabel"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="4" class="pb-2 mb-4">
                <v-checkbox
                  v-model="dependente.necessidadeEspecial"
                  :label="locale[local].screen.formDependenteResponsivo.necessidadesEspeciaisLabel"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="pb-2"
                v-show="dependente.necessidadeEspecial"
              >
                <v-select
                  v-model.number="dependente.codNecessidadeEspecial"
                  :items="listaTiposNecessidades"
                  item-text="descricao"
                  item-value="codNecessidade"
                  :label="locale[local].screen.formDependenteResponsivo.tipoNecessidadesEspeciaisLabel"
                  filled
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" class="pt-0 pb-2">
                <v-text-field
                  v-model="dependente.observacao"
                  :label="locale[local].screen.formDependenteResponsivo.observacaoLabel"
                  filled
                  :rules="[v => !!v || locale[local].rules.observacaoLabel]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0 pb-2">
                <v-file-input
                  v-model="dependente.comprovante"
                  chips
                  :rules="[v => !!v || locale[local].rules.comprovanteLabel]"
                  show-size
                  :label="locale[local].screen.formDependenteResponsivo.comprovanteLabel"
                  filled
                ></v-file-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card>

        <v-btn text @click="voltarEstagio(index)" class="mr-4">
          {{ index === 1 ? locale[local].screen.formDependenteResponsivo.btnCancelar : locale[local].screen.formDependenteResponsivo.btnVoltar }}
        </v-btn>

        <v-btn
          :loading="loadingButton"
          :disabled="loadingButton"
          color="primary"
          @click="avancarEstagio(index)"
        >
          {{ index === quantidadePassos ? locale[local].screen.formDependenteResponsivo.btnGravar : locale[local].screen.formDependenteResponsivo.btnAvancar }}
        </v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
import Service from "@/components/api/Service";
import Util from "@/components/api/Util";
import moment from "moment";
import { locale } from '../../locale/locale';

export default {
  data: vm => ({
    service: new Service(),
    util: new Util(),

    estagioForm: 0,
    quantidadePassos: 4,

    // Loaders
    loadingButton: false,

    // Listas
    listaUFs: [],
    listaDependencias: [],
    listaTiposNecessidades: [],

    //
    dependente: {},

    dependentePadrao: {
      nome: "Teste Imagem",
      codDependencia: 1,
      cpf: "02370455080",
      dataNascimento: "13/10/1994",
      sexo: true,
      nomePai: "Testenildo",
      nomeMae: "Testenilva",
      CEP: "99150000",
      cidade: "Marau",
      uf: "RS",
      numeroCertidao: 123,
      livro: "ABC",
      folha: "1AB2C32",
      matriculaCertidao: "123",
      dataCertidao: "10/10/2010",
      observacao: "teste",
      estudante: false,
      necessidadeEspecial: false,
      codNecessidadeEspecial: 0,
      comprovante: null
    },

    //Controllers de Data
    dateCertidao: new Date().toISOString().substr(0, 10),
    menuCertidao: false,
    dateNascimento: new Date().toISOString().substr(0, 10),
    menuNascimento: false,

    //Mascáras
    maskNumCertidao: "#######",
    maskData: "##/##/####",
    maskCPF: "###.###.###-##",
    maskCep: "#####-###",

    //Validadores
    validDadosGerais: true,
    validDadosAdicionais: true,
    validDadosMatricula: true,
    validDadosDependente: true,
    desabilitarLocalidade: false,

    // Regras de Validação
    nascimentoRules: [
      v => !!v || locale[window.local].rules.dataLabel,
      v => vm.dataValida(v) || locale[window.local].rules.dataInvalidaLabel
    ],
    certidaoRules: {
      required: v => !!v || locale[window.local].rules.dataLabel,
      dataValida: v => vm.dataValida(v) || locale[window.local].rules.dataInvalidaLabel
    },
    cepRules: [
      v => !!v || locale[window.local].rules.cepLabel,
      v => (v && v.length >= 9) || locale[window.local].rules.invalidCepLabel
    ]
  }),
  created() {
    if (process.env.NODE_ENV === "development") {
      this.dependente = Object.assign({}, this.dependentePadrao);
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    defineTamanhoTela(tam) {
      let oldQuantidadePassos = this.quantidadePassos;

      this.quantidadePassos = tam;

      if (this.estagioForm > tam) {
        this.estagioForm = tam;
      } else if (this.estagioForm === 2) {
        if (oldQuantidadePassos === 2 && tam === 4) {
          this.estagioForm = 1;
        } else if (oldQuantidadePassos === 3 && tam === 2) {
          this.estagioForm = 1;
        }
      }
    },
    limparFormulario() {
      if (process.env.NODE_ENV === "production") {
        this.dependente = {};
      }
      this.estagioForm = 1;
    },
    dataValida(data) {
      if (data) {
        var dataFormatoPadrao = this.util.parseDate(data); //YYYY-MM-DD
        return moment(dataFormatoPadrao).isValid();
      } else {
        return true;
      }
    },
    async getCidadeCEP() {
      try {
        this.desabilitarLocalidade = false;

        var response = await this.service.getCidadeCEP(this.dependente.CEP);

        if (
          response.data.localidade !== null &&
          response.data.localidade !== "" &&
          response.data.localidade !== undefined
        ) {
          this.dependente.uf = response.data.uf;
          this.dependente.cidade = response.data.localidade;
          this.desabilitarLocalidade = true;
        } else {
          this.dependente.uf = "";
          this.dependente.cidade = "";
        }
      } catch (error) {
        this.desabilitarLocalidade = false;
      }
    },
    voltarEstagio(estagioAtual) {
      if (estagioAtual > 1) {
        this.estagioForm = estagioAtual - 1;
      } else {
        this.$emit("esconder-formulario");
      }
    },
    avancarEstagio(estagioAtual) {
      if (this.quantidadePassos === 4) {
        switch (estagioAtual) {
          case 1:
            if (this.$refs.formDadosGerais[0].validate()) {
              this.estagioForm = 2;
            }
            return null;
          case 2:
            if (this.$refs.formDadosAdicionais[0].validate()) {
              this.estagioForm = 3;
            }
            return null;
          case 3:
            if (this.$refs.formDadosMatricula[0].validate()) {
              this.estagioForm = 4;
            }
            return null;
          case 4:
            if (this.$refs.formDependente[0].validate()) {
              this.adicionarDependente();
            }
            return null;
        }
      } else {
        if (estagioAtual < 2) {
          if (
            this.$refs.formDadosGerais[0].validate() &
            this.$refs.formDadosAdicionais[0].validate()
          ) {
            this.estagioForm = 2;
          }
        } else {
          if (
            this.$refs.formDadosMatricula[0].validate() &&
            this.$refs.formDependente[0].validate()
          ) {
            this.adicionarDependente();
          }
        }
      }
    },
    async adicionarDependente() {
      try {
        this.loadingButton = true;

        var dataCertidao = this.util.parseDate(this.dependente.dataCertidao);
        var dataNascimento = this.util.parseDate(
          this.dependente.dataNascimento
        );

        // Normaliza as string, para remover caracteres especiais.
        var dependente = {
          codPessoa: parseInt(localStorage.getItem("codPessoa")),
          nome: this.util.normalizeString(this.dependente.nome),
          sexo: this.dependente.sexo,
          codDependencia: this.dependente.codDependencia,
          CPF: this.dependente.cpf,
          dtNascimento: dataNascimento,
          nomePai: this.util.normalizeString(this.dependente.nomePai),
          nomeMae: this.util.normalizeString(this.dependente.nomeMae),
          codCep: this.dependente.CEP,
          cidade: this.util.normalizeString(this.dependente.cidade),
          uf: this.dependente.uf,
          numCertidao: this.dependente.numeroCertidao,
          livroCertidao: this.dependente.livro,
          folhaCertidao: this.dependente.folha,
          matriculaCertidao: this.dependente.matriculaCertidao,
          dtCertidao: dataCertidao,
          estudante: this.dependente.estudante,
          deficienteFisico: this.dependente.necessidadeEspecial,
          codNecessidade: this.dependente.codNecessidadeEspecial,
          observacao: this.dependente.observacao
        };

        var resposta = await this.service.gravarDependente(dependente);

        if (resposta.status === 200) {
          if (resposta.data.logErroApp) {
            throw new Error(resposta.data.logErroApp[0].erro);
          }

          var sequencia = resposta.data.retorno[0].msgErro.split("|")[1];

          var respostaUploadImagem = {};

          try {
            respostaUploadImagem = await this.service.uploadImagem(
              this.dependente.comprovante,
              sequencia
            );
          } catch (erro) {
            respostaUploadImagem.status = 500;
          }

          var mensagem = "";
          var tipoMensagem = "";

          if (respostaUploadImagem.status === 200) {
            mensagem = locale[window.local].screen.formDependenteResponsivo.error01Label;
            tipoMensagem = "Sucesso";
          } else {
            const respostaExcluirWebDependente = await this.service.excluirWebDependente(
              parseInt(sequencia)
            );

            if (respostaExcluirWebDependente.status === 200) {
              mensagem = locale[window.local].screen.formDependenteResponsivo.error03Label;
              tipoMensagem = "Erro";
            } else {
              mensagem = locale[window.local].screen.formDependenteResponsivo.error04Label;  
              tipoMensagem = "Alerta";
            }
          }

          this.loadingButton = false;
          this.$emit("esconder-formulario");
          this.$emit("mostrar-mensagem", mensagem, tipoMensagem);
        } else {
          throw new Error(
            locale[window.local].screen.formDependenteResponsivo.error05Label
          );
        }
      } catch (erro) {
        this.loadingButton = false;
        console.log(erro);
        console.log(erro.message);
        this.$emit("mostrar-alerta", erro.message);
      }
    }
  },
  watch: {
    dateNascimento() {
      this.dependente.dataNascimento = this.util.formatDate(
        this.dateNascimento
      );
    },
    dateCertidao() {
      this.dependente.dataCertidao = this.util.formatDate(this.dateCertidao);
    }
  },
  computed: {
    tamanhoTela() {
      //https://stackoverflow.com/questions/57041559/vuetify-breakpoints-for-columns
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
        case "sm":
        case "md":
          this.defineTamanhoTela(4);
          return 4;
        case "lg":
        case "xl":
          this.defineTamanhoTela(2);
          return 2;
        default:
          this.defineTamanhoTela(4);
          return 4;
      }
    }
  }
};
</script>
